import { ToolbarItem } from "./ToolbarItem";
import { ToolbarMenuItem } from "./ToolbarMenuItem";
import { Toolbar } from "../Toolbar";
import { IToolbarItem } from "./IToolbarItem";

export class ToolbarMenu extends ToolbarItem {

    private items: Array<ToolbarMenuItem> = [];

    public constructor(control: HTMLElement, toolbar: Toolbar) {
        super(control, toolbar);

        let menu = (control.children.item(1) as HTMLElement);
        for (let i = 0; i < menu.children.length; i++) {
            let menuItem = (menu.children.item(i) as HTMLElement);
            if (menuItem.classList.contains("dropdown-item")) {
                this.items.push(new ToolbarMenuItem(menuItem, this, toolbar));
            }
        }
    }

    public findItemById(id: string): IToolbarItem {
        for (let item of this.items) {
            if (item.id == id) {
                return item;
            }
        }
        return null;
    }
}
